import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPrevious = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m16.063 9.281-1.026 1.049 3.124 3.124H11v1.459h7.16l-3.124 3.124 1.026 1.049 4.9-4.9z", "data-name": "icon/arrownext2", transform: "rotate(-90 5.871 15.094)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgArrowPrevious);
export { ForwardRef as ReactComponent };
